import MemberList from "./pages/MemberList";

import { AppRoute } from "src/types/routes";

export const settingUserRoutes:AppRoute[] = [
    { path: "users", element: <MemberList /> },
];

